import type { BoxTheme } from '@lub0v/santa-utils';

export const THEME_ORDER_EXPERIMENT = 'creation-theme-order-v2';
const BASE_ORDER = ['halloween', 'alpine', 'egypt', 'winter', 'cherry-blossom', 'pixel'] as const;
const VARIANTS = ['A', 'B', 'C', 'D', 'E', 'F'] as const;
export type ThemeOrderVariant = typeof VARIANTS[number];
export interface ThemeOrderAssignment {
  variant: ThemeOrderVariant;
  themes: readonly BoxTheme[];
}
export interface ThemeClickPlacement {
  theme_position: number;
  theme_order_variant?: ThemeOrderVariant;
  theme_order_experiment?: string;
}

/** Balanced rotations: each theme occupies every position once; Alpine and Winter never touch. */
export const THEME_ORDERS: readonly ThemeOrderAssignment[] = VARIANTS.map((variant, index) => ({
  variant,
  themes: [...BASE_ORDER.slice(index), ...BASE_ORDER.slice(0, index)] as BoxTheme[],
}));

/** Versioned, deterministic assignment, independent of the pricing experiment. */
export function assignThemeOrder(identity: string): ThemeOrderAssignment {
  let hash = 2166136261;
  for (const character of `${THEME_ORDER_EXPERIMENT}:${identity}`) {
    hash = Math.imul(hash ^ character.charCodeAt(0), 16777619) >>> 0;
  }
  return THEME_ORDERS[hash % THEME_ORDERS.length];
}

let browserSeed: string | undefined;
const STORAGE_KEY = `ss:${THEME_ORDER_EXPERIMENT}:seed`;
export function getThemeOrder(userId?: number | null): ThemeOrderAssignment {
  if (userId != null) return assignThemeOrder(`user:${userId}`);
  if (!browserSeed) {
    try { browserSeed = window.localStorage.getItem(STORAGE_KEY) || undefined; } catch { /* Optional storage. */ }
    if (!browserSeed) {
      browserSeed = globalThis.crypto.randomUUID();
      try { window.localStorage.setItem(STORAGE_KEY, browserSeed); } catch { /* Keep stable in memory. */ }
    }
  }
  return assignThemeOrder(`browser:${browserSeed}`);
}
